export class Timer {
  constructor() {
    this.elapsedMs = 0;
    this.running = false;
  }

  start() {
    this.elapsedMs = 0;
    this.running = true;
  }

  pause() {
    this.running = false;
  }

  resume() {
    this.running = true;
  }

  reset() {
    this.elapsedMs = 0;
    this.running = false;
  }

  /** @param {number} dtSeconds */
  update(dtSeconds) {
    if (!this.running) return;
    this.elapsedMs += dtSeconds * 1000;
  }

  /**
   * Format milliseconds as mm:ss.s
   * @param {number|null} ms
   */
  static format(ms) {
    if (ms == null || ms < 0 || !Number.isFinite(ms)) return '--:--.-';
    const totalTenths = Math.floor(ms / 100);
    const tenths = totalTenths % 10;
    const totalSec = Math.floor(totalTenths / 10);
    const sec = totalSec % 60;
    const min = Math.floor(totalSec / 60);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(min)}:${pad(sec)}.${tenths}`;
  }
}
